<template>
  <div class="container-fluid cluster-page">
    <div class="row justify-content-end my-4">
      <!-- Push RTC button -->
      <div class="col-auto">
        <button @click="pushRTC" class="btnCluster rtcBtn">Push RTC</button>
      </div>
      <!-- Data Analytic button -->
      <div class="col-auto">
        <button @click="goToAnalytics" class="btnCluster analyticsBtn">
          <analyticIcon></analyticIcon>
          Data Analytics
        </button>
      </div>
    </div>

    <div class="row">
      <div
        class="col-auto"
        style="width: 324px; margin-top: 0; height: 1107px; z-index: 1"
      >
        <div
          class="h-100 row justify-content-start align-content-start align-items-start"
        >
          <!-- Total Cost -->
          <div class="col-12 m-0 g-4">
            <div class="large-card p-0">
              <TotalCost :items="totalCost" />
            </div>
          </div>
          <!-- This week total energy, co2 emissions reduction, last hour operational hours and last hour brightness level -->
          <div
            class="col-12 g-4 d-flex flex-column gap-4 mb-0 overflow-auto"
            style="height: 754px"
          >
            <div
              v-for="item in cards"
              class="flex-shrink-0"
              style="min-height: 158px"
            >
              <card
                class="h-100"
                type="small"
                :img="item.img"
                :subtitle="item.subtitle"
                :title="item.title"
                :value="item.value"
                @open-light-modal="openLightModal"
              >
              </card>
            </div>
            <!-- <LeftCards @open-light-modal="openLightModal" :cards="cards" /> -->
          </div>
        </div>
      </div>

      <!-- Map -->
      <div
        class="col g-4"
        style="
          margin-top: 0;
          z-index: 1;
          display: flex;
          flex-direction: column;
          height: 1107px;
        "
      >
        <!-- ClusterMap (make it fill more space) -->
        <div style="flex: 1 1 70%; margin-bottom: 20px">
          <div class="large-card p-0 h-100">
            <ClusterMap
              v-if="markers && markers.length"
              v-model:markers="markers"
              @on-fullscreen="openClusterMapModal"
              :legends="legendsArray"
            />
          </div>
        </div>

        <!-- VoltageChart (reduce height and push it slightly lower) -->
        <div style="flex: 1 1 30%">
          <div class="large-card h-100">
            <VoltageChart :items="voltageChart" />
          </div>
        </div>
      </div>
      <!-- Event Logs -->
      <div
        class="col-auto"
        style="width: 324px; margin-top: 0; height: 1107px; z-index: 1"
      >
        <div
          class="h-100 row justify-content-start align-content-start align-items-start"
        >
          <div class="col-12 m-0 g-4">
            <div class="large-card p-0">
              <ClusterMaster
                @on-change-scheduler="onChangeScheduler"
                @on-stop="onSliderStop"
                @on-click="onTekan"
                :timerLeft="timerleft"
                v-bind:is-override="successOverride"
                :selected-duration="option"
              />
            </div>
          </div>
          <div class="col-12 g-4" style="height: 100%">
            <EventLogs :eventLogs="eventLogs" />
          </div>
          <div class="col-12 g-4" style="height: 564px">
            <!-- <card> </card> -->
            <RightCards :card="rightCard" />
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-6 g-4">
        <div class="large-card">
          <CurrentChart :items="currentChart" />
        </div>
      </div>
      <div class="col-6 g-4">
        <div class="large-card">
          <EnergyChart :items="energyChart" />
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="successModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="successModal"
      data-bs-backdrop="static"
      aria-hidden="true"
    >
      <SuccessModal
        :btnText="'Done'"
        :message="successMessage"
        :onSave="successSave"
      />
    </div>
    <div
      class="modal fade"
      id="warningModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="warningModal"
      data-bs-backdrop="static"
      aria-hidden="true"
    >
      <WarningModal
        @on-save="warningSave"
        :note="'This user will no longer be available if you agree to proceed.'"
      />
    </div>
    <div
      class="modal fade"
      id="lightModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="lightModal"
      data-bs-backdrop="static"
      aria-hidden="true"
    >
      <ListLightModal
        ref="lightModal"
        @close-modal="closeLightModal"
        :list="listoflights"
      />
    </div>
    <div
      class="modal fade"
      id="clusterMapModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="clusterMapModal"
      data-bs-backdrop="static"
      aria-hidden="true"
    >
      <ClusterMapModal
        ref="clusterMapModal"
        @close-modal="closeClusterMapModal"
        :legends="legendsArray"
      />
    </div>
    <my-modal
      :visible="modal.showModal"
      :title="modal.title"
      :titledescription="modal.description"
      :message="modal.message"
      :type="modal.type"
      :showNote="modal.showNote"
      :showConfirm="modal.showConfirm"
      :showCancel="modal.showCancel"
      @confirm="handleConfirm"
      @cancel="handleCancel"
      :confirmMessageButton="modal.confirmMessageButton"
    >
    </my-modal>
    <my-modal
      :visible="modal.showModalWarning"
      :title="modal.title"
      :titledescription="modal.description"
      :message="modal.message"
      :type="modal.type"
      :showNote="modal.showNote"
      :showConfirm="modal.showConfirm"
      :showCancel="modal.showCancel"
      @confirm="handleConfirmWarning"
      @cancel="handleCancelWarning"
      :confirmMessageButton="modal.confirmMessageButton"
    >
    </my-modal>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import ClusterMaster from "./cluster/ClusterMaster.vue";
import CurrentChart from "./cluster/currentChart.vue";
import EnergyChart from "./cluster/energyChart.vue";
import EventLogs from "./cluster/EventLogs.vue";
import LeftCards from "./cluster/LeftCards.vue";
import ListLightModal from "./cluster/ListLightModal.vue";
import RightCards from "./cluster/RightCards.vue";
import TotalCost from "./cluster/TotalCost.vue";
import VoltageChart from "./cluster/voltageChart.vue";
import ClusterMap from "./maps/maps/clusterMap.vue";
import markerData from "../data/api/listMarker.json";
import ClusterMapModal from "./cluster/ClusterMapModal.vue";
import SuccessModal from "./uikits/modal/SuccessModal.vue";
import WarningModal from "./uikits/modal/WarningModal.vue";
import moment from "moment";
// svg
import analyticIcon from "@/assets/svg/analytic-icon.vue";
import { ref } from "vue";
import { formatTo2Decimal } from "@/utils";
import checkIcon from "@/assets/images/right.png";
import seruIcon from "@/assets/images/seru.png";

const alertRef = ref(null);

export default {
  components: {
    TotalCost,
    LeftCards,
    RightCards,
    EventLogs,
    CurrentChart,
    EnergyChart,
    VoltageChart,
    ClusterMap,
    ClusterMaster,
    ListLightModal,
    ClusterMapModal,
    SuccessModal,
    WarningModal,
    analyticIcon,
  },
  data() {
    return {
      modal: {
        showModal: false,
        showModalWarning: false,
        title: "SUCCESS !",
        description: "",
        message: "",
        type: "success", //warning,
        confirmMessageButton: "Done",
        showNote: true,
        showConfirm: true,
        showCancel: true,
      },
      showModal: false,
      successOverride: false,
      timerleft: "",
      legendsArray: [],
      durationSelect: "",
      markers: [],
      successModal: null,
      successMessage: "",
      successSave: () => {},
      warningModal: null,
      warningSave: () => {},
      lightModal: null,
      clusterMapModal: null,
      currentChart: {
        Label: [],
        Data: [],
      },
      energyChart: {
        Label: [],
        Data: [],
      },
      voltageChart: {
        Label: [],
        Data: [],
      },
      totalCost: "RM 0",
      eventLogs: [],
      cards: [],
      rightCard: [],
      socket: null,
      clusterName: "",
      listoflights: [],
      option: "",
    };
  },
  watch: {
    successOverride() {},
    option() {},
  },
  created() {},
  mounted() {
    // get override schduler timer
    this.getOverrideSchedulerTimer();

    // modal declaration
    this.lightModal = new Modal(document.getElementById("lightModal"), {});
    const lightModalElement = document.getElementById("lightModal");
    lightModalElement.addEventListener("show.bs.modal", () => {
      this.$refs.lightModal.initializeModal();
    });
    this.connectSocket();

    this.getCardData();
    this.getGraphData();
    // this.getMarkers();

    // modal declaration
    this.clusterMapModal = new Modal(
      document.getElementById("clusterMapModal"),
      {}
    );
    const clusterMapModalElement = document.getElementById("clusterMapModal");
    clusterMapModalElement.addEventListener("show.bs.modal", () => {
      this.$refs.clusterMapModal.initializeModal(this.markers);
    });
    this.successModal = new Modal(document.getElementById("successModal"), {});
    this.warningModal = new Modal(document.getElementById("warningModal"), {});
  },
  beforeUnmount() {
    if (this.socket) {
      this.socket.close();
    }
  },
  methods: {
    handleConfirm() {
      this.modal = {
        showModal: false,
        showModalWarning: false,
      };
    },
    handleCancel() {
      this.modal = {
        showModal: false,
      };
    },
    // handleClose(){

    //   console.log("handle close")
    // },
    getOverrideSchedulerTimer() {
      this.$http
        .get(":11004/api/v1/override/cluster/" + this.$route.query.id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.successOverride = response.Status;
            this.timerleft = response.TimeEnd != "" ? response.TimeEnd : 0;
          }
        });
    },
    connectSocket() {
      this.socket = new WebSocket(
        process.env.VUE_APP_WS_URL + ":11000/ws/cluster/" + this.$route.query.id
      );

      this.socket.onopen = () => {
        // console.log("web socket connected");
      };
      this.socket.onmessage = ({ data }) => {
        // console.log(JSON.parse(data));
        this.parseData(JSON.parse(data));
      };
    },
    parseData(data) {
      // console.log(data);
      this.legendsArray = [];
      // Lights
      if (data.DeviceListStatus != null) {
        for (var i = 0; i < data.DeviceListStatus.length; i++) {
          // determine icon
          let icon = "";
          if (
            data.DeviceListStatus[i].LightStatus == 1 &&
            data.DeviceListStatus[i].ConnStatus == 1
          ) {
            icon = "LightsOnlineOn";
          } else if (
            data.DeviceListStatus[i].LightStatus == 0 &&
            data.DeviceListStatus[i].ConnStatus == 1
          ) {
            icon = "LightsOnlineOff";
          } else
          {
            icon = "LightsOffline";
          }

          let obj = {
            id: data.DeviceListStatus[i].DeviceID,
            lat: data.DeviceListStatus[i].Latitude,
            long: data.DeviceListStatus[i].Longitude,
            name: data.DeviceListStatus[i].DeviceName,
            latLng: [
              data.DeviceListStatus[i].Latitude,
              data.DeviceListStatus[i].Longitude,
            ],
            icon: icon,
            flag: "light",
            clusterID: this.$route.query.id,
            show: true,
            // "LightsOffline" : "LightsOnlineOff" : "LightsOnlineOn"
          };
          this.markers.push(obj);

          // for list of lights
          let list = {
            key: `${i}`,
            DeviceName: data.DeviceListStatus[i].DeviceName,
            Status:
              data.DeviceListStatus[i].ConnStatus == "1" ? "Green" : "Red",
            DeviceID: data.DeviceListStatus[i].DeviceID,
            clusterID: this.$route.query.id,
          };

          this.listoflights.push(list);
        }
      }

      // Feeder Pillar
      if (data.FeederPillarList != null) {
        for (var i = 0; i < data.FeederPillarList.length; i++) {
          let obj = {
            id: i,
            name: data.FeederPillarList[i].FpName,
            icon: "FeederPillar",
            lat: data.FeederPillarList[i].Latitude,
            long: data.FeederPillarList[i].Longitude,
            latLng: [
              data.FeederPillarList[i].Latitude,
              data.FeederPillarList[i].Longitude,
            ],
            flag: "feederpillar",
            show: true,
          };
          this.markers.push(obj);
        }
      }

      // GatewayList
      if (data.GatewayList != null) {
        for (var i = 0; i < data.GatewayList.length; i++) {
          let obj = {
            id: data.GatewayList[i].GatewayID,
            name: data.GatewayList[i].GatewayName,
            icon:
              data.GatewayList[i].GatewayStatus == true
                ? "GatewayOnline"
                : "GatewayOffline",
            lat: data.GatewayList[i].Latitude,
            long: data.GatewayList[i].Longitude,
            latLng: [
              data.GatewayList[i].Latitude,
              data.GatewayList[i].Longitude,
            ],
            flag: "gateway",
            show: true,
          };
          this.markers.push(obj);
        }
      }

      // lux
      if (data.LuxListStatus != null) {
        console.log(data.LuxListStatus);
        for (var i = 0; i < data.LuxListStatus.length; i++) {
          let obj = {
            id: data.LuxListStatus[i].DeviceID,
            name: data.LuxListStatus[i].DeviceName,
            icon:
              data.LuxListStatus[i].Status == 1 ? "LuxOnline" : "LuxOffline",
            lat: data.LuxListStatus[i].Latitude,
            long: data.LuxListStatus[i].Longitude,
            latLng: [
              data.LuxListStatus[i].Latitude,
              data.LuxListStatus[i].Longitude,
            ],
            flag: "lux",
            show: true,
          };
          this.markers.push(obj);
        }
      }

      // legend
      console.log(data.LegendMetadata);
      if (data.LegendMetadata != null) {
        for (var i = 0; i < data.LegendMetadata.length; i++) {
          let obj = {
            index: data.LegendMetadata[i].Index,
            label: data.LegendMetadata[i].Label,
            value: data.LegendMetadata[i].Value,
            icon: data.LegendMetadata[i].Keyword,
            checked: true,
          };
          this.legendsArray.push(obj);
        }
      }
    },
    getGraphData() {
      this.$http
        .get(":11000/api/v1/cluster/graphs/" + this.$route.query.id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            // Voltage graph
            let formattedVoltageData = formatTo2Decimal(
              response.GraphVoltage.AvgGraph
            );
            let formattedVoltageDate = response.GraphVoltage.Period.map(
              (date) => moment(date).format("YYYY-MM-DD")
            );

            this.voltageChart = {
              Label: formattedVoltageDate,
              Data: formattedVoltageData,
            };

            // Current graph
            let formattedCurrentData = formatTo2Decimal(
              response.GraphCurrent.AvgGraph
            );
            let formattedCurrentDate = response.GraphCurrent.Period.map(
              (date) => moment(date).format("YYYY-MM-DD")
            );

            this.currentChart = {
              Label: formattedCurrentDate,
              Data: formattedCurrentData,
            };

            // Energy graph
            let formattedEnergyData = formatTo2Decimal(
              response.GraphEnergy.AvgGraph
            );
            let formattedEnergyDate = response.GraphEnergy.Period.map((date) =>
              moment(date).format("YYYY-MM-DD")
            );

            this.energyChart = {
              Label: formattedEnergyDate,
              Data: formattedEnergyData,
            };
          }
        });
    },
    getCardData() {
      this.$http
        .get(":11000/api/v1/cluster/" + this.$route.query.id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            this.clusterName = response.ClusterName;
            this.setHeaderComponent();

            // total cost card
            this.totalCost = response.TotalCost.toFixed(2);

            // event log
            this.eventLogs = [];
            if (response.ClusterEventLogs != null) {
              for (var i = 0; i < response.ClusterEventLogs.length; i++) {
                let obj = {
                  time: moment(response.ClusterEventLogs[i].EventTime).format(
                    "HH:mm"
                  ),
                  date: moment(response.ClusterEventLogs[i].EventTime).format(
                    "YYYY-MM-DD"
                  ),
                  methods: response.ClusterEventLogs[i].Method,
                  log: response.ClusterEventLogs[i].EventDescription,
                };
                this.eventLogs.push(obj);
              }
            }

            // this week total energy, co2 emission reduction, last hour operational lights and last hour brightness level
            this.cards = [
              {
                img: require("@/assets/images/icon/energy.png"),
                title: response.TotalEnergy.toFixed(2) + " kWh",
                subtitle: "This Week\nTotal Energy",
                showTooltip: true,
              },
              {
                img: require("@/assets/images/icon/co2.png"),
                title: response.CO2EmissionReduction.toFixed(2) + " Kg",
                subtitle: "Co2 Emissions\nReduction",
              },
              {
                img: require("@/assets/images/icon/light.png"),
                value: 87,
                title:
                  response.LastHourOperationalLights +
                  " out of " +
                  response.TotalLightsInCluster,
                subtitle: "Last Hour\nOperational Light(s)",
              },
              {
                img: require("@/assets/images/icon/light.png"),
                title: response.LastHourBrightness + " %",
                subtitle: "Last Hour\nBrightness Level",
              },
            ];

            this.rightCard = [
              {
                img: "status",
                title: response.LastHourClusterStatus,
                subtitle: "Last Hour\nCluster Status",
              },
              {
                img: "uprate",
                title: response.CommunicationUprate + "%",
                subtitle: "Communication\nUprate",
              },
              {
                img: "schedule",
                title: response.ScheduleUsed,
                subtitle: "Schedule Profile",
              },
            ];
          }
        });
    },
    onTekan(brightness, onoff, flag) {
      // console.log("trigger on tekan");
      this.sendCommand(brightness, onoff, flag);
    },
    onSliderStop(brightness, onoff, flag) {
      // console.log("trigger on slide");
      this.sendCommand(brightness, onoff, flag);
    },
    sendCommand(brightness, onoff, f) {
      // console.log("br", brightness);
      // console.log("onoff", onoff);
      // console.log(f);
      if (f != "timerhabis") {
        let status = onoff == true ? 1 : 0;
        let br = brightness / 10;

        // set brightness
        this.$http
          .post(
            ":11004/api/v1/lights/cluster/" +
              this.$route.query.id +
              "/" +
              status +
              "/" +
              br
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;

              this.successMessage = response.Message;

              this.successSave = () => this.successModal.hide();
              this.successModal.show();
            }
          });
      }
    },
    handleCancelWarning() {
      this.option = "";
      this.modal = {
        showModal: false,
        showModalWarning: false,
      };
    },
    handleConfirmWarning() {
      this.$http
        .post(
          ":11004/api/v1/override/cluster/" +
            this.$route.query.id +
            "/" +
            Math.floor(this.option / 60)
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            const { Status, Message } = response;
            if (Status === true) {
              this.successOverride = true;
            }
            this.modal = {
              showModal: true,
              showModalWarning: false,
              title: "SUCCESS!",
              description: Message,
              message: "",
              type: "success", //warning,
              confirmMessageButton: "Done",
              showNote: false,
              showConfirm: true,
              showCancel: false,
            };
            // this.successMessage = Message;
            // this.successSave = () => {
            //   this.successModal.hide();
            // };
            // this.successModal.show();
            // this.warningModal.hide();
          }
        });
    },
    onChangeScheduler(option) {
      // console.log({ option });
      this.option = option;
      this.modal = {
        showModal: false,
        showModalWarning: true,
        title: "WARNING!",
        description: "Are you sure?",
        message:
          "This user will no longer be available if you agree to proceed.",
        confirmMessageButton: "Yes",
        type: "warning",
        showNote: true,
        showConfirm: true,
        showCancel: true,
      };
      // this.warningSave = () => {
      //   console.log(Math.floor(option / 60));
      //   // set override scheduler

      // };
      // this.warningModal.show();
    },
    goToAnalytics() {
      this.$route.query.flag = "cluster";
      this.$router.push({
        path: "analytics",
        query: this.$route.query,
      });
    },
    pushRTC() {
      this.$http
        .post(":11004/api/v1/rtc/cluster/" + this.$route.query.id)
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            this.$swal({
              title: `<div class="success-title"><img src="${checkIcon}" alt="check" /><p class="header">SUCCESSFUL!</p></div><p class="success-text">${response}</p>`,

              confirmButtonText: "Done",

              customClass: {
                title: "swal2-content",
                popup: "success-popup swal2-content",
                confirmButton: "success-button",
              },
              buttonsStyling: false,
            });

            // this.successMessage = "RTC push successful";
            // this.successSave = () => {
            //   this.successModal.hide();
            // };
            // this.successModal.show();
          }
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message ||
            "Something went wrong. Please try again.";

          this.$swal({
            title: `<div class="warning-title"><img src="${seruIcon}" alt="check" /><p class="header">WARNING!</p></div>`,
            html: `<p class="warning-subtitle">Note</p><p class="warning-subtitle2">${message}</p>`,
            // showCancelButton: true,
            confirmButtonText: "OK",
            // cancelButtonText: "No",
            customClass: {
              title: "swal2-content",
              popup: "warning-popup swal2-content",
              confirmButton: "warning-button",
              // cancelButton: "warning-cancel-button",
            },
            buttonsStyling: false,
          }).then((result) => {
            console.log(result);
          });
        });
    },
    openLightModal() {
      // pass value list lampu yg di marshall from websocket
      this.lightModal.show();
    },
    closeLightModal() {
      this.lightModal.hide();
    },
    openClusterMapModal() {
      this.clusterMapModal.show();
    },
    closeClusterMapModal() {
      this.clusterMapModal.hide();
    },
    getMarkers() {
      // this.markers = markerData.message.markers.map((item) => {
      //   return {
      //     ...item,
      //     latLng: [item.lat, item.long],
      //   };
      // });
    },
    setHeaderComponent() {
      this.$store.dispatch("common/setHeaderComponent", {
        title: "Cluster Page - " + this.clusterName,
        subtitle: "",
        showBack: false,
      });
    },
  },
  unmounted() {
    this.clusterMapModal.hide();
  },
};
</script>

<style lang="scss" scoped>
h2 {
  color: #009a78;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 32px;
}

.cluster-page {
  padding: 0;
}

.btnCluster {
  display: flex;
  height: 44px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1px solid #218863;
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.rtcBtn {
  width: 130px;
  color: #218863;
  background: #fff;

  :hover {
    background: #218863;
    color: #fff;
  }
}

.analyticsBtn {
  width: 150px;
  color: #fff;
  background: #218863;
}
</style>

<style lang="scss">
.info {
  width: 25px;
  height: 25px;
  background: #fff;
  border: 2px solid #1daeef;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 15px;
  top: 15px;
  color: #1daeef;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
}

.large-card {
  height: 353px;
  padding: 35px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 4px 8px 0px rgba(215, 227, 235, 0.25);

  .green {
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(142deg, #bcefdb 41.95%, #a0cce7 96.79%);
    box-shadow: 0px 4px 8px 0px rgba(215, 227, 235, 0.25);
  }
}

.card-small {
  height: 160px !important;
  border-radius: 8px !important;
  background: #fff !important;
  box-shadow: 0px 4px 8px 0px rgba(215, 227, 235, 0.25) !important;

  .card-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 19px 15px 19px 35px !important;
  }

  .card-footer {
    padding: 13px 16px !important;
    color: #1daeef;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    span {
      cursor: pointer;
    }
  }

  .widget-content {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .image {
    min-width: 63px;
    min-height: 63px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: var(
      --Gradient,
      linear-gradient(142deg, #bcefdb 29.66%, #a0cce7 96.79%)
    );

    img {
      scale: 0.667;
      object-fit: contain;
    }
  }

  .title {
    margin: 0;
    color: #ababab;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    white-space: pre-line;

    strong {
      color: #000;
      text-shadow: 0px 4px 8px rgba(215, 227, 235, 0.25);
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    }

    p {
      color: #009a78;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin: 0;
    }
  }

  .subtitle {
    margin: 0;
    color: #ababab;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    white-space: pre-line;
  }

  .card-footer {
    border-top: 1px solid #e9e9e9;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 60px;
  }
}
</style>
